<template>
  <div class="ma-4" app>
    <v-container fluid class="full-height">
      <v-row>
        <v-col md="12">
          <UserTable />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import UserTable from "./Components/UserTable";
export default {
  name: "Users",
  components: {
    UserTable
  },
  mounted() {
    console.log("dispatching users get users");
    this.$store.dispatch("getUsers");
  }
};
</script>
